
const swiperContainerP = document.getElementsByClassName('carousel_product');

for (var i = 0; i < swiperContainerP.length; i++) {
  swiperContainerP[i].classList.add('swiperP' + i);
  const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination');

  if (swiperPage) {
    swiperPage.classList.add('pageP' + i);
  }

  // Find the corresponding thumbnail swiper
  const thumbsContainer = swiperContainerP[i].nextElementSibling;
  if (thumbsContainer && thumbsContainer.classList.contains('carousel_thumbs')) {
    thumbsContainer.classList.add('swiperThumbs' + i);

    // Initialize thumbnail swiper
    const thumbsSwiper = new Swiper('.swiperThumbs' + i, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchSlidesProgress: true,
    });

    // Initialize main swiper and link thumbs
    var mySwiperP = new Swiper('.swiperP' + i, {
      direction: 'horizontal',
      loop: false,
      speed: 420,
      slidesPerView: 1.08,
      spaceBetween: 5,
      effect: 'slide',
      thumbs: {
        swiper: thumbsSwiper,
      },
      breakpoints: {
      996: {
        slidesPerView: 1,
        effect: 'fade',
      },
    },
    });
  }
}


/* Open Cart */

// const detailLinks = qsa('details a')

// detailLinks.forEach((link) => {
// 	link.addEventListener('click', (e) => {
// 		e.stopPropagation()
// 	})
// })

// /* Details Animator */
// const details = document.querySelectorAll('details')

// if (details) {
// 	details.forEach((targetDetail) => {
// 		targetDetail.addEventListener('click', function (e) {
// 			if (targetDetail.hasAttribute('open')) {
// 				e.preventDefault()
// 				targetDetail.classList.add('closing')
// 				setTimeout(() => {
// 					targetDetail.removeAttribute('open')
// 					targetDetail.classList.remove('closing')
// 				}, 390)
// 			}
// 		})
// 	})
// }


/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Liquid Ajax Cart */

let cartOriginatingTrigger = null

function focusCartClose() {
	const cartDrawer = document.querySelector('#CartDrawer')
	const closeButton = cartDrawer && cartDrawer.querySelector('.close-cart-btn')
	if (closeButton) closeButton.focus({ preventScroll: true })
}

if (typeof liquidAjaxCart !== 'undefined' && typeof liquidAjaxCart.subscribeToCartAjaxRequests === 'function') liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
		if (state.requestType == 'add') {
			const form = state.info && state.info.initiator
			let btnInner = ''

			const btn = form && form.querySelector('button[type="submit"]')
			cartOriginatingTrigger = btn
			if (btn) {
				btnInner = btn.innerHTML
				btn.innerHTML = 'ADDING'
			}

			subscribeToResult((state) => {
				const btn = form && form.querySelector('button[type="submit"]')
				if (state.responseData.ok) {
					cartOpen()
					document.querySelectorAll('.header__cart').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'))
					setTimeout(focusCartClose, 100)
				}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})


/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');
if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1,
	})
}


// const subMenuItems = document.querySelectorAll('.desktop__sub-menu .menu a')
// const subMenuInitImage = document.querySelector('.desktop__sub-menu .image-holder img ')
// if(subMenuItems && subMenuInitImage) {
// 	subMenuItems.forEach(item => {
//   const hoverImgUrl = item.dataset.collectionImg;
//   if (hoverImgUrl && hoverImgUrl.length > 1) {
//     item.addEventListener('mouseenter', () => {
//        subMenuInitImage.src = hoverImgUrl;
//     });
//   }
// });
// }

document.addEventListener("DOMContentLoaded", () => {
	// main DOM content loaded

	const header = document.querySelector('#shopify-section-header');
	// intially disabled pointer events on the home link , so it doesnt trigger
	// as soon redirected to a new page
	if (header) {
		const logo = header.querySelector('.header__logo');
		if (logo) {
			setTimeout(() => {
				logo.style.pointerEvents = 'all';
			}, 500)
		}
	}


	const btnSubMenu = document.querySelector('.open-sub-menu')
	const btnSearch = document.querySelector('.open-search')
		const searchBar = document.querySelector('.search-bar-overlay')
		const subMenu = document.querySelector('.desktop__sub-menu')
		const darkOverlay = document.querySelector('.dark-overlay')
		const mobileToggle = document.querySelector('#mobile-nav-toggle')
		const mobileMenu = document.querySelector('.mobile__dropdown-menu')
		let activeOverlayTrigger = null

		if (btnSubMenu && subMenu) {
			btnSubMenu.setAttribute('aria-expanded', 'false')
			btnSubMenu.addEventListener('mouseenter', function (event) {
				subMenu.classList.add('active')
				btnSubMenu.setAttribute('aria-expanded', 'true')
				if (darkOverlay) darkOverlay.classList.add('active')
			})
			btnSubMenu.addEventListener('click', function (event) {
				event.preventDefault()
				activeOverlayTrigger = btnSubMenu
				subMenu.classList.add('active')
				btnSubMenu.setAttribute('aria-expanded', 'true')
				if (darkOverlay) darkOverlay.classList.add('active')
				const firstLink = subMenu.querySelector('a[href]')
				if (firstLink) firstLink.focus({ preventScroll: true })
			})
		}

		if (darkOverlay) {
			darkOverlay.addEventListener('mouseenter', function (event) {
				if (subMenu) subMenu.classList.remove('active')
				if (searchBar) searchBar.classList.remove('active')
				darkOverlay.classList.remove('active')
				if (btnSubMenu) btnSubMenu.setAttribute('aria-expanded', 'false')
				if (btnSearch) btnSearch.setAttribute('aria-expanded', 'false')
			})
		}


		if (btnSearch && searchBar) {
			btnSearch.setAttribute('aria-expanded', 'false')
			btnSearch.addEventListener('click', function (event) {
				event.preventDefault()
				activeOverlayTrigger = btnSearch
				searchBar.classList.toggle('active')
				const isOpen = searchBar.classList.contains('active')
				btnSearch.setAttribute('aria-expanded', String(isOpen))
				if (darkOverlay) darkOverlay.classList.toggle('active', isOpen)
				const searchInput = searchBar.querySelector('input[type="search"]')
				if (isOpen && searchInput) searchInput.focus({ preventScroll: true })
			})
		}

		document.querySelectorAll('.header__menu-desktop a').forEach(link => {
		link.addEventListener('mouseenter', event => {
			if (subMenu) subMenu.classList.remove('active')
			if (searchBar) searchBar.classList.remove('active')
			if (darkOverlay) darkOverlay.classList.remove('active')
			if (btnSubMenu) btnSubMenu.setAttribute('aria-expanded', 'false')
			if (btnSearch) btnSearch.setAttribute('aria-expanded', 'false')
		});
	});


const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach(item => {
  const header = item.querySelector('.accordion-header');
  const content = item.querySelector('.accordion-content');

  if (!header || !content) return;

  header.setAttribute('aria-expanded', String(item.classList.contains('active')));
  content.hidden = !item.classList.contains('active');

  header.addEventListener('click', () => {
    // Close all other items
    accordionItems.forEach(i => {
      if (i !== item) {
        i.classList.remove('active');
        const otherHeader = i.querySelector('.accordion-header');
        const otherContent = i.querySelector('.accordion-content');
        if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
        if (otherContent) {
          otherContent.style.maxHeight = null;
          otherContent.hidden = true;
        }
      }
    });

    // Toggle this item
    if (item.classList.contains('active')) {
      item.classList.remove('active');
      header.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = null;
      content.hidden = true;
    } else {
      item.classList.add('active');
      header.setAttribute('aria-expanded', 'true');
      content.hidden = false;
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});

  
  const links = document.querySelectorAll('.desktop__sub-menu a[data-target-cover-img]');
  links.forEach(link => {
    link.addEventListener('mouseenter', () => {


      const targetHandle = link.dataset.targetCoverImg;
      const allCovers = document.querySelectorAll('.collection-cover-image');
      const targetCover = document.querySelector(`.cover-for-${targetHandle}`);
	  const defaultCover = document.querySelector('.cover-for__inital-image');
	

      if (targetCover) {
		allCovers.forEach(img => img.classList.add('inactive'));
		allCovers.forEach(img => img.classList.remove('active'));
        
		targetCover.classList.add('active')
      } else {
		allCovers.forEach(img => img.classList.add('inactive'));
		allCovers.forEach(img => img.classList.remove('active'));

			if (defaultCover) defaultCover.classList.add('active')
	  }

    });

 	});


		function addLinkToInstaFeed() {
			
			const instafeed = document.querySelector('#insta-feed');
			if (!instafeed) return; 

			const heading = instafeed.querySelector('h2');
			if (!heading) return; 

			const appLink = document.querySelector('.instafeed-bottom-link-wrapper a')
			let linkFromApp = '';
			if(appLink) {
				 linkFromApp = appLink.href
			} 
			const link = document.createElement('a');
			link.href = linkFromApp; 
			link.textContent = '@yuichi.artisans';
			link.className = 'profile-link h2'; 
			
			heading.insertAdjacentElement('afterend', link);
		}
		

		setTimeout(addLinkToInstaFeed, 700)


			function openCollectionFilters(){
				const filter = document.querySelector('.collection__filter');
				if (filter) {
					filter.classList.add('active')
					filter.setAttribute('aria-hidden', 'false')
					if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true')
					const dialog = filter.querySelector('.filter-wrap')
					if (dialog) dialog.focus({ preventScroll: true })
				}
			}

			function closeCollectionFilters(restoreFocus){
				const filter = document.querySelector('.collection__filter');
				if (filter) {
					filter.classList.remove('active')
					filter.setAttribute('aria-hidden', 'true')
					if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false')
					if (restoreFocus && filterBtn) filterBtn.focus({ preventScroll: true })
				}
			}

	const filterBtn = document.querySelector('.product_collection .open-filters');

	    if (filterBtn) {
	      filterBtn.setAttribute('aria-expanded', 'false')
	      filterBtn.addEventListener('click', (e) => {
	        e.preventDefault();
	        activeOverlayTrigger = filterBtn
	        openCollectionFilters();
	      });
	    }

	const closeBtns = document.querySelectorAll('.close-product-filter');

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
	        e.preventDefault();
	        if (typeof closeCollectionFilters === 'function') {
	          closeCollectionFilters(true);
	        }
	      });
	    });


  const applyFilter = document.querySelector('.apply_filter_btn');
  if (applyFilter) {
	      applyFilter.addEventListener('click', (e) => {
	      e.preventDefault()
	      const url = applyFilter.dataset.targetUrl
	      if (!applyFilter.disabled && url) {
	        closeCollectionFilters(false);
	        window.location.href = url;
	      }
	    });
	  }

	  if (mobileToggle && mobileMenu) {
	    mobileToggle.setAttribute('aria-expanded', 'false')
	    mobileToggle.addEventListener('click', function () {
	      activeOverlayTrigger = mobileToggle
	      this.classList.toggle('active')
	      mobileMenu.classList.toggle('active')
	      const isOpen = mobileMenu.classList.contains('active')
	      mobileToggle.setAttribute('aria-expanded', String(isOpen))
	      if (isOpen) {
	        const firstLink = mobileMenu.querySelector('a[href]')
	        if (firstLink) firstLink.focus({ preventScroll: true })
	      }
	    });
	  }

	  document.querySelectorAll('.header__cart').forEach((cartTrigger) => {
	    cartTrigger.setAttribute('aria-expanded', 'false')
	    cartTrigger.addEventListener('click', function () {
	      cartOriginatingTrigger = cartTrigger
	      setTimeout(() => {
	        const isOpen = document.body.classList.contains('js-my-cart-open')
	        document.querySelectorAll('.header__cart').forEach((trigger) => trigger.setAttribute('aria-expanded', String(isOpen)))
	        if (isOpen) focusCartClose()
	      }, 0)
	    })
	  })

	  document.addEventListener('click', function (event) {
	    const closeControl = event.target.closest && event.target.closest('.close-cart-btn, .cart-modal__bg')
	    if (!closeControl) return
	    setTimeout(() => {
	      if (!document.body.classList.contains('js-my-cart-open')) {
	        document.querySelectorAll('.header__cart').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'))
	        if (cartOriginatingTrigger) cartOriginatingTrigger.focus({ preventScroll: true })
	      }
	    }, 0)
	  })

	  document.addEventListener('keydown', function (event) {
	    if (event.key === 'Tab' && document.body.classList.contains('js-my-cart-open')) {
	      const drawer = document.querySelector('#CartDrawer')
	      const controls = drawer ? Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')) : []
	      if (drawer && controls.length) {
	        const first = controls[0]
	        const last = controls[controls.length - 1]
	        if (!drawer.contains(document.activeElement)) {
	          event.preventDefault()
	          const target = event.shiftKey ? last : first
	          target.focus({ preventScroll: true })
	        } else if (event.shiftKey && document.activeElement === first) {
	          event.preventDefault()
	          last.focus({ preventScroll: true })
	        } else if (!event.shiftKey && document.activeElement === last) {
	          event.preventDefault()
	          first.focus({ preventScroll: true })
	        }
	      }
	      return
	    }

	    if (event.key !== 'Escape') return

	    if (document.body.classList.contains('js-my-cart-open')) {
	      document.body.classList.remove('js-my-cart-open')
	      document.querySelectorAll('.header__cart').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'))
	      if (cartOriginatingTrigger) cartOriginatingTrigger.focus({ preventScroll: true })
	    } else if (document.querySelector('.collection__filter.active')) {
	      closeCollectionFilters(true)
	    } else if (mobileMenu && mobileMenu.classList.contains('active')) {
	      mobileMenu.classList.remove('active')
	      mobileToggle.classList.remove('active')
	      mobileToggle.setAttribute('aria-expanded', 'false')
	      mobileToggle.focus({ preventScroll: true })
	    } else if (searchBar && searchBar.classList.contains('active')) {
	      searchBar.classList.remove('active')
	      if (darkOverlay) darkOverlay.classList.remove('active')
	      btnSearch.setAttribute('aria-expanded', 'false')
	      btnSearch.focus({ preventScroll: true })
	    } else if (subMenu && subMenu.classList.contains('active')) {
	      subMenu.classList.remove('active')
	      if (darkOverlay) darkOverlay.classList.remove('active')
	      btnSubMenu.setAttribute('aria-expanded', 'false')
	      btnSubMenu.focus({ preventScroll: true })
	    } else if (activeOverlayTrigger) {
	      activeOverlayTrigger.focus({ preventScroll: true })
	    }
	  })



	// end content loaded
})

// Section - Collection List

const collectionTitles = document.querySelectorAll('.collection-title');
const mediaItems = document.querySelectorAll('.img-wrap');

collectionTitles.forEach(title => {
  title.addEventListener('mouseenter', () => {
    const targetHandle = title.dataset.collectionTarget;

    // Remove 'active' from all media items
    mediaItems.forEach(item => item.classList.remove('active'));

    const matchingItem = document.querySelector(`.img-wrap[data-collection-handle="${targetHandle}"]`);
    if (matchingItem) {
      matchingItem.classList.add('active');
    }
  });
});


// Select all Swiper containers with the class
const swiperContainers = document.querySelectorAll('.carousel-version-one');

swiperContainers.forEach((container, index) => {
  // Add unique class per instance
  const uniqueClass = 'swiper-instance-' + index;
  container.classList.add(uniqueClass);

  // Initialize Swiper
  new Swiper('.' + uniqueClass, {
	effect: "coverflow",
    loop: false,
    slidesPerView: 1.7,
    spaceBetween: 70,
    speed: 700,
    centeredSlides: true,
    initialSlide: 0,
    slideToClickedSlide: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false,
      scale: 0.87 // smaller side slides
    },
  });
});






// localization form
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.style.maxHeight = '0px';
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

   openSelector() {
    this.elements.button.focus();
    const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    this.elements.button.setAttribute('aria-expanded', (!expanded).toString());

    if (!expanded) {
      // Open: set maxHeight to scrollHeight
      this.elements.panel.style.maxHeight = this.elements.panel.scrollHeight + 'px';
    } else {
      // Close: set maxHeight to 0
      this.elements.panel.style.maxHeight = '0';
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
// end localization



// Filters on collection page
document.querySelectorAll('.filters-menu__link').forEach(link => {
  link.addEventListener('click', (event) => {

     document.querySelectorAll('.filters-menu__link').forEach(item => {
      item.classList.remove('selected');
    });

    link.classList.add ('selected')

    const targetUrl = link.getAttribute('data-href');
    const applyButton = document.querySelector('.apply_filter_btn');

    if (applyButton && targetUrl) {
      applyButton.setAttribute('data-target-url', targetUrl);
      applyButton.disabled = false;
      applyButton.setAttribute('aria-disabled', 'false');
    }
  });
});
